import React, { useState , useEffect} from "react";
import { Box, Stack, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TopBar from "../components/TopBar";

import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../services/firebase";

import EventCard from "../components/EventCard";
import CustomButton from "../components/CustomButton";

const API_URL = process.env.REACT_APP_API_URL

export const SharedStateContext = React.createContext();

const Dashboard = () => {
  const navigate = useNavigate(); 
  const [user, setUser] = useState({});
  const [eventList, setEventList] = useState([]);
  const [eventDeleted, setEventDeleted] = useState(false);
  const [switchTriggered, setSwitchTriggered] = useState(false)


  const handleCreateEventClick = () => {
    navigate("/CreateEvent");
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser)
      } else {
        setUser(currentUser)
        navigate('/Login')
      }
    })

    return () => unsubscribe()
  }, [user])

  useEffect(() => {
    try {
      if (!user || !user.email) return;
      const showEvents = async () => {
        fetch(`${API_URL}/firebase/get-user-events`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            userEmail: user.email,
          })
        }).then((res) => res.json())
        .then((res) => {
          setEventList(res)
        })
      };
      showEvents();
    } catch (e) {
      console.log(e)
    }
  }, [user, eventDeleted]);

  return (
    <Box className="max_container" sx = {{ marginTop: 8 }}>
      <TopBar/>
      <Divider color="gray" width="100%" sx = {{ marginTop: 4, marginBottom: 4 }}/>
      <Stack className="items-center gap-4">
        <h3 className="text-2px uppercase font-medium text-white">{user.email}</h3>
      </Stack>
      <Stack className="px-2 mt-[50px]">
        <h3 className="uppercase font-medium text-white mb-2">Your Events</h3>
        <Divider color="gray" width="100%" />
        <SharedStateContext.Provider value={{ switchTriggered, setSwitchTriggered }}>
        {
          eventList && eventList.length > 0 ? 
          eventList.sort((x, y) => {
              const dateX = new Date(x.Date);
              const dateY = new Date(y.Date);
              return dateX - dateY;
            })
            .map((item) => (
              <div key={item.id}>
                <EventCard
                  event={item}
                  user={user}
                  pastEvent={false}
                  SharedStateContext={SharedStateContext}
                />
              </div>
            ))
          :
          <></>
        }
        </SharedStateContext.Provider>
      </Stack>
      <Stack spacing={2} className="mt-12 px-12">
        <CustomButton 
          myFunction={handleCreateEventClick}
          text={"Create New Event"}
        />
        <CustomButton 
          myFunction={() => window.open(`/ActiveEvent/${user.uid}`)}
          text={"Download QRCode"}
        />
      </Stack>
    </Box>
  );
};

export default Dashboard;
